import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  SiniestrosService,
  Siniestro,
} from "../../../../../shared/services/siniestrosViales.service";
import Swal from "sweetalert2";
import { Utils } from "../../../../../shared/utils/Utils";
@Component({
  selector: "app-siniestros-viales",
  templateUrl: "./siniestros-viales.component.html",
  styleUrls: ["./siniestros-viales.component.scss"],
})
export class SiniestrosVialesComponent implements OnInit {
  siniestros: Siniestro[] = [];
  filteredTableItems: Siniestro[] = [];
  searchText: string = "";
  pageSize1: number = 5;
  page1: number = 1;
  stateFilter: string | undefined;
  sortColumn: any;
  sortDirection: string | undefined;
  totalItems: number = 0;

  constructor(
    private siniestrosService: SiniestrosService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.listarSiniestros();
  }

  listarSiniestros(): void {
    this.siniestrosService.getSiniestros().subscribe({
      next: (data) => {
        this.siniestros = data;
        this.filteredTableItems = this.siniestros;
      },
      error: (err) => console.error("Error cargando siniestros", err),
    });
  }

  filterData(): void {
    const term = this.searchText.trim().toLowerCase();
    const base = [...this.siniestros].filter((item) => {
      if (this.stateFilter === "active") {
        return this.esActivo(item);
      }
      if (this.stateFilter === "inactive") {
        return !this.esActivo(item);
      }
      return true;
    });

    this.filteredTableItems = !term
      ? base
      : base.filter((item) => {
          const consecutivo = String(item.consecutivo ?? "").toLowerCase();
          const nombre = String(item.fecha_siniestro ?? "").toLowerCase();
          const descripcion = String(item.hora_siniestro ?? "").toLowerCase();
          const placa = String(item.placa ?? "").toLowerCase();
          const tipo_siniestro = String(
            item.tipoSiniestroData?.nombre ?? "",
          ).toLowerCase();
          const severidad = String(
            item.nivelSeveridadData?.severidad ?? "",
          ).toLowerCase();
          const estado = this.esActivo(item) ? "activo" : "inactivo";
          const id = String(item.id ?? "").toLowerCase();
          return (
            consecutivo.includes(term) ||
            nombre.includes(term) ||
            descripcion.includes(term) ||
            placa.includes(term) ||
            tipo_siniestro.includes(term) ||
            severidad.includes(term) ||
            estado.includes(term) ||
            id.includes(term)
          );
        });

    this.sortCurrentData();
  }

  activarSiniestro(siniestro: Siniestro): void {
    Swal.fire({
      title: "Activar",
      text: `¿Desea activar el siniestro ${siniestro.consecutivo}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.siniestrosService.activar(siniestro.id).subscribe({
          next: () => {
            Swal.fire("Éxito", "Siniestro activado correctamente", "success");
            this.listarSiniestros();
          },
          error: (err) =>
            Swal.fire(
              "Error",
              err.error?.message || "No se pudo activar",
              "error",
            ),
        });
      }
    });
  }

  inactivarSiniestro(siniestro: Siniestro): void {
    Swal.fire({
      title: "Inactivar",
      text: `¿Desea inactivar el siniestro ${siniestro.consecutivo}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.siniestrosService.inactivar(siniestro.id).subscribe({
          next: () => {
            Swal.fire("Éxito", "Siniestro inactivado correctamente", "success");
            this.listarSiniestros();
          },
          error: (err) =>
            Swal.fire(
              "Error",
              err.error?.message || "No se pudo inactivar",
              "error",
            ),
        });
      }
    });
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  esActivo(item: Siniestro): boolean {
    return String(item?.estado) === "1";
  }

  private sortCurrentData(): void {
    if (!this.sortColumn) {
      return;
    }
    this.filteredTableItems.sort((a: any, b: any) => {
      const valueA = this.getSortableValue(a, this.sortColumn);
      const valueB = this.getSortableValue(b, this.sortColumn);
      if (valueA < valueB) {
        return this.sortDirection === "asc" ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
  }

  private getSortableValue(item: any, column: string): string {
    if (column === "estado") {
      return this.esActivo(item) ? "1" : "0";
    }
    return String(item?.[column] ?? "").toLowerCase();
  }

editarSiniestro(siniestro: Siniestro): void {
  Swal.fire({
    title: "Editar siniestro",
    text: `¿Desea editar el siniestro ${siniestro.consecutivo}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, editar",
    cancelButtonText: "Cancelar"
  }).then((result) => {
    if (result.isConfirmed) {
      this.router.navigate(['editar/editar-siniestros-viales', siniestro.id]);
    }
  });
}


}
